import { Grid } from 'e100-react-components';
import React from 'react';
import { Typography, FlatCard } from 'shared/components';
import { EmailConsent } from './EmailConsent/EmailConsent';
import { useIntl } from 'react-intl';

export const ConfirmActivationStep = () => {
  const { formatMessage } = useIntl();
  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography variant="h5">
          <b>{formatMessage({ id: 'almostReadyToStartYourFreeTrial' })}</b>
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <br />
      </Grid>
      <Grid item xs={12}>
        <EmailConsent />
      </Grid>
      <Grid item xs={12} md={6}>
        <FlatCard>
          <Typography>
            {formatMessage({ id: 'noChargesDuring14DayTrial' })}
          </Typography>
          <Typography>
            {formatMessage({ id: 'afterTrialSubscription' })}
          </Typography>
        </FlatCard>
      </Grid>
    </Grid>
  );
};
